import { render, staticRenderFns } from "./number-of-contracts-apart.vue?vue&type=template&id=56d80524&"
import script from "./number-of-contracts-apart.vue?vue&type=script&lang=js&"
export * from "./number-of-contracts-apart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports